/* tslint:disable */
/* eslint-disable */
/* @relayHash 1f73f1356895ec86a357a8d9a6d84bb2 */

import { ConcreteRequest } from "relay-runtime";
export type ForgotPasswordInput = {
    emailOrUsername: string;
    clientMutationId?: string | null;
};
export type ForgotPasswordMutationVariables = {
    input: ForgotPasswordInput;
};
export type ForgotPasswordMutationResponse = {
    readonly forgotPassword: {
        readonly success: boolean;
    } | null;
};
export type ForgotPasswordMutation = {
    readonly response: ForgotPasswordMutationResponse;
    readonly variables: ForgotPasswordMutationVariables;
};



/*
mutation ForgotPasswordMutation(
  $input: ForgotPasswordInput!
) {
  forgotPassword(input: $input) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ForgotPasswordInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "forgotPassword",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForgotPasswordPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ForgotPasswordMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ForgotPasswordMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ForgotPasswordMutation",
    "id": null,
    "text": "mutation ForgotPasswordMutation(\n  $input: ForgotPasswordInput!\n) {\n  forgotPassword(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'c6218d4d521832099aae6cb28b8e6234';
export default node;
